import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import clsx from "clsx";
import * as MuiIcons from "@material-ui/icons";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import { Badge, Collapse, List } from "@material-ui/core";
import BarChartIcon from "@material-ui/icons/BarChart";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import BusinessIcon from "@material-ui/icons/Business";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import EventIcon from "@material-ui/icons/Event";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";
import BlockIcon from "@material-ui/icons/Block";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import RotateRight from "@material-ui/icons/RotateRight";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import ForumIcon from "@material-ui/icons/Forum";
import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { canShowMenu as hasMenuAccess } from "../helpers/menuAccess";
import { SettingsContext } from "../context/Settings/SettingsContext";
import {
  getRelevantWhatsApps,
  isWhatsappOffline,
} from "../helpers/whatsappStatus";
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import { SocketContext } from "../context/Socket/SocketContext";
import TableChartIcon from '@material-ui/icons/TableChart';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import ToDoList from "../pages/ToDoList/";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { AllInclusive, AttachFile, BlurCircular, DeviceHubOutlined, Schedule, AttachMoney, Visibility } from '@material-ui/icons';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import usePlans from "../hooks/usePlans";
import Typography from "@material-ui/core/Typography";
import useVersion from "../hooks/useVersion";
import { listBoards } from "../services/kanban";
import { iconOptions } from "../components/KanbanBoard/ColumnModal";
import SidebarFlyout, {
  SidebarTooltip,
  MENU_ICON_SIZE,
  SUBMENU_ICON_SIZE,
} from "./SidebarFlyout";

const useStyles = makeStyles((theme) => ({
  ListSubheader: {
    height: 26,
    marginTop: "-15px",
    marginBottom: "-10px",
  },
  flyoutTitle: {
    padding: theme.spacing(1, 2),
    fontWeight: 500,
  },
  // Marcador aplicado ao ListItemIcon dos subitens. Vazio de proposito: o
  // tamanho e definido em menuRoot para vencer por ordem, nao por !important.
  subItemIcon: {},
  // O Mui-selected padrao quase nao aparece sobre o fundo do drawer. A barra
  // usa box-shadow (e nao border-left) para nao deslocar o conteudo do item.
  menuRoot: {
    // Esta div e a raiz do menu dentro da <ul> do drawer. Sem largura explicita
    // ela fica a merce do display da lista; com 100% os itens ocupam toda a
    // largura util e nao sobra faixa vazia na lateral.
    width: "100%",
    boxSizing: "border-box",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: theme.palette.action.selected,
      boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}`,
    },
    // O ListItemIcon reserva 56px fixos por padrao. Com largura automatica, o
    // espaco entre icone e texto passa a ser o mesmo padding lateral do item.
    "& .MuiListItemIcon-root": {
      minWidth: "auto",
      marginRight: theme.spacing(2),
    },
    // Tamanho unico por nivel: 24px nos itens, 20px nos subitens. As duas
    // regras tem a mesma especificidade, entao a segunda vence por vir depois.
    "& .MuiListItemIcon-root .MuiSvgIcon-root": {
      fontSize: MENU_ICON_SIZE,
    },
    "& $subItemIcon .MuiSvgIcon-root": {
      fontSize: SUBMENU_ICON_SIZE,
    },
  },
  // Indenta os subitens sob o pai. Com a barra retraida o indent empurraria os
  // icones contra a borda, entao so vale com o menu aberto.
  submenuNested: {
    paddingLeft: 15,
  },
  // Barra retraida: some tudo que nao e o icone. Sem isso o texto vazaria pela
  // direita, ja que o ListItemIcon agora tem largura automatica.
  menuCollapsed: {
    "& .MuiListItemText-root": {
      display: "none",
    },
    "& .MuiListItemIcon-root": {
      marginRight: 0,
    },
    // Sem texto, o icone e o unico conteudo do item. Centralizar mantem os
    // subitens (20px) alinhados aos itens (24px) na mesma coluna.
    "& .MuiListItem-root": {
      justifyContent: "center",
    },
    // Os chevrons de abrir/fechar submenu sao filhos diretos do ListItem.
    "& .MuiListItem-root > .MuiSvgIcon-root": {
      display: "none",
    },
  },
}));

// Estado da barra compartilhado com os itens, para nao ter que repassar as
// mesmas props em cada uma das ~27 chamadas de ListItemLink.
const SidebarUIContext = React.createContext({ flyoutActive: false });

// "/" so casa com "/" — sem isso o Dashboard ficaria destacado em toda rota.
const isRouteActive = (pathname, to) => {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
};

const submenuStorageKey = (companyId, submenuKey) =>
  `sidebarSubmenu:${companyId}:${submenuKey}`;

/**
 * Estado aberto/fechado de um submenu: a escolha do usuario (persistida) tem
 * precedencia sobre o padrao definido pela empresa.
 */
const useSubmenuState = (submenuKey, submenuBehavior) => {
  const companyId = localStorage.getItem("companyId");
  const storageKey = submenuStorageKey(companyId, submenuKey);

  const [open, setOpen] = useState(() => {
    const pref = localStorage.getItem(storageKey);
    if (pref) return pref === "open";
    return submenuBehavior === "expanded";
  });

  useEffect(() => {
    if (localStorage.getItem(storageKey)) return;
    setOpen(submenuBehavior === "expanded");
  }, [submenuBehavior, storageKey]);

  const toggle = useCallback(() => {
    setOpen((prev) => {
      localStorage.setItem(storageKey, prev ? "closed" : "open");
      return !prev;
    });
  }, [storageKey]);

  return [open, toggle];
};

function ListItemLink(props) {
  const { icon, primary, to, className } = props;
  const { flyoutActive } = useContext(SidebarUIContext);
  const location = useLocation();

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <SidebarTooltip active={flyoutActive} title={primary}>
      <li>
        <ListItem
          button
          dense
          selected={isRouteActive(location.pathname, to)}
          component={renderLink}
          className={className}
        >
          {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
          <ListItemText primary={primary} />
        </ListItem>
      </li>
    </SidebarTooltip>
  );
}

const CLIENT_CENTRAL_COLOR_LIGHT = "rgb(77, 0, 195)"; // tema claro (inalterado)
const CLIENT_CENTRAL_COLOR_DARK = "#c4a7ff";          // tema escuro (mais claro, AA em texto pequeno sobre #424242)

const CLIENT_CENTRAL_ITEMS = [
  { menu: "relatorio_utilizacao", to: "/usage-report", labelKey: "mainDrawer.listItems.usageReport", Icon: TableChartIcon },
  { menu: "clientes", to: "/clientes", labelKey: "mainDrawer.listItems.clientes", Icon: BusinessIcon },
  { menu: "agenda", to: "/followup", labelKey: "mainDrawer.listItems.followUp", Icon: EventIcon },
];

const CAMPAIGN_ITEMS = [
  { menu: "campanhas_lista", to: "/campaigns", labelKey: "mainDrawer.listItems.campaignsList", Icon: ListIcon },
  { menu: "camp_lista_ctt", to: "/contact-lists", labelKey: "mainDrawer.listItems.contactLists", Icon: PeopleIcon },
  { menu: "camp_configs", to: "/campaigns-config", labelKey: "mainDrawer.listItems.campaignsConfig", Icon: SettingsOutlinedIcon },
];

const KANBAN_COLOR = "#2196f3";

const FORBIDDEN_ITEMS = [
  { menu: "termos_proibidos", to: "/forbidden-words", labelKey: "mainDrawer.listItems.forbiddenWordsRegister", Icon: BlockIcon },
  { menu: "termos_proibidos_relatorio", to: "/forbidden-words-report", labelKey: "mainDrawer.listItems.forbiddenWordsReport", Icon: AssignmentLateIcon },
];

const MainListItems = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const clientCentralColor =
    theme.palette.type === "dark"
      ? CLIENT_CENTRAL_COLOR_DARK
      : CLIENT_CENTRAL_COLOR_LIGHT;
  const {
    collapsed,
    onItemClick,
    sidebarBehavior,
    sidebarSubmenuBehavior,
    drawerVariant,
  } = props;
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, menus, handleLogout } = useContext(AuthContext);
  const { getSetting } = useContext(SettingsContext);
  const location = useLocation();
  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, toggleCampaignSubmenu] = useSubmenuState(
    "campaigns",
    sidebarSubmenuBehavior
  );
  const [openClientCentralSubmenu, toggleClientCentralSubmenu] = useSubmenuState(
    "clientCentral",
    sidebarSubmenuBehavior
  );
  const [openFluxosSubmenu, toggleFluxosSubmenu] = useSubmenuState(
    "fluxos",
    sidebarSubmenuBehavior
  );
  const [openForbiddenSubmenu, toggleForbiddenSubmenu] = useSubmenuState(
    "forbiddenWords",
    sidebarSubmenuBehavior
  );

  // O flyout so faz sentido com a barra retraida, em desktop, e se a empresa
  // nao desligou o hover.
  const flyoutActive =
    Boolean(collapsed) &&
    sidebarBehavior !== "collapsed_no_hover" &&
    drawerVariant === "permanent";

  const submenuNestedClass = collapsed ? undefined : classes.submenuNested;
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [kanbanBoards, setKanbanBoards] = useState([]);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false); const history = useHistory();
  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const { getPlanCompany } = usePlans();
  
  const [version, setVersion] = useState(false);
  
  
  const { getVersion } = useVersion();

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
      
      // Carregar boards do Kanban se o plano permitir
      if (planConfigs.plan.useKanban) {
        fetchKanbanBoards();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchKanbanBoards = async () => {
    try {
      // summary: o menu só usa id/nome/ícone/ordem; a lista completa trazia
      // todos os cards de todos os boards a cada carga do app.
      const { data } = await listBoards({ summary: true });
      setKanbanBoards(data.boards || []);
    } catch (err) {
      if (err?.response?.status === 403) {
        setKanbanBoards([]);
      } else {
        console.error("Erro ao carregar boards:", err);
      }
    }
  };



  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    // Entrar no canal principal para receber eventos de kanban boards
    const mainChannel = `company-${companyId}-mainchannel`;
    socket.emit("joinChatBox", mainChannel);

    // Listener para atualizar boards do Kanban no menu lateral
    const handleKanbanBoard = (data) => {
      if (data.action === "create" || data.action === "update" || data.action === "delete" || data.action === "seed") {
        fetchKanbanBoards();
      }
    };

    const handleBoardsReordered = () => {
      fetchKanbanBoards();
    };

    socket.on("kanban:board", handleKanbanBoard);
    socket.on("kanban:boardsReordered", handleBoardsReordered);

    return () => {
      socket.off("kanban:board", handleKanbanBoard);
      socket.off("kanban:boardsReordered", handleBoardsReordered);
      socket.disconnect();
    };
  }, [socketManager]);

  useEffect(() => {
    if (localStorage.getItem("cshow")) {
      setShowCampaigns(true);
    }
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const relevant = getRelevantWhatsApps(user, menus, whatsApps);
      setConnectionWarning(relevant.some(isWhatsappOffline));
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps, user, menus]);

  const handleClickLogout = () => {
    //handleCloseMenu();
    handleLogout();
  };

  // Função utilitária para verificar permissão de menu
  const canShowMenu = (menuKey) => hasMenuAccess(user, menus, menuKey);

  const getBoardIconComponent = (iconName) => {
    if (!iconName || typeof iconName !== "string") return AttachMoney;

    const option = iconOptions.find((item) => item.name === iconName);
    if (option?.icon) return option.icon;

    return MuiIcons[iconName] || AttachMoney;
  };

  // Item sem `menu` tem a visibilidade decidida pelo bloco pai.
  const visibleSubItems = (items) =>
    items.filter((item) => !item.menu || canShowMenu(item.menu));

  // Alguns itens (boards do Kanban) se distinguem pela query string, entao
  // podem trazer o proprio teste de rota ativa.
  const isSubItemActive = (item) =>
    item.isActive ? item.isActive() : isRouteActive(location.pathname, item.to);

  // O pai acende quando a rota atual pertence a um dos filhos visiveis.
  const isSubmenuActive = (items) => visibleSubItems(items).some(isSubItemActive);

  // `tooltip` so vale para os subitens do Collapse com a barra retraida: dentro
  // do flyout o rotulo ja esta visivel ao lado do icone.
  const renderSubItems = (items, { color, onNavigate, tooltip } = {}) =>
    visibleSubItems(items).map((item) => {
      const { key, to, Icon } = item;
      const label = item.label ?? i18n.t(item.labelKey);
      return (
        <SidebarTooltip key={key || to} active={Boolean(tooltip)} title={label}>
          <ListItem
            button
            dense
            selected={isSubItemActive(item)}
            onClick={() => {
              history.push(to);
              if (onNavigate) onNavigate();
            }}
          >
            <ListItemIcon className={classes.subItemIcon}>
              <Icon style={color ? { color } : undefined} />
            </ListItemIcon>
            <ListItemText
              primary={color ? <span style={{ color }}>{label}</span> : label}
            />
          </ListItem>
        </SidebarTooltip>
      );
    });

  const renderFlyoutPanel = (title, items, color) => ({ closeFlyout }) => (
    <>
      <Typography variant="subtitle2" className={classes.flyoutTitle}>
        {title}
      </Typography>
      <Divider />
      <List component="div" disablePadding>
        {renderSubItems(items, { color, onNavigate: closeFlyout })}
      </List>
    </>
  );

  // Os boards do Kanban compartilham o mesmo pathname e so se distinguem pela
  // query string, entao o destaque precisa olhar o boardId.
  const activeBoardId =
    location.pathname === "/kanban-board"
      ? new URLSearchParams(location.search).get("boardId")
      : null;
  const onKanbanRoute = location.pathname === "/kanban-board";

  // Montado a partir dos boards carregados da API, entao nao pode ser uma
  // constante de modulo como os demais submenus.
  const fluxosItems = [
    {
      key: "all-boards",
      to: "/kanban-board",
      label: i18n.t("mainDrawer.listItems.kanbanAll"),
      Icon: FilterAltIcon,
      isActive: () => onKanbanRoute && !activeBoardId,
    },
    ...[...kanbanBoards]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .map((board) => ({
        key: `board-${board.id}`,
        to: `/kanban-board?boardId=${board.id}`,
        label: board.name,
        Icon: getBoardIconComponent(board.icon),
          isActive: () => activeBoardId === String(board.id),
      })),
  ];

  return (
    <SidebarUIContext.Provider value={{ flyoutActive }}>
    <div
      onClick={onItemClick}
      className={clsx(classes.menuRoot, collapsed && classes.menuCollapsed)}
    >
      {canShowMenu("dashboard") && (
        <ListItemLink
          to="/"
          primary={i18n.t("mainDrawer.listItems.dashboard")}
          icon={<BarChartIcon style={{ color: "#CC0036" }} />}
        />
      )}
      {/* Só com Avaliações habilitadas (Configurações → Opções ou a própria tela). */}
      {canShowMenu("avaliacoes") && getSetting("userRating") === "enabled" && (
        <ListItemLink
          to="/avaliacoes"
          primary={i18n.t("mainDrawer.listItems.ticketRatings")}
          icon={<MuiIcons.Star style={{ color: "#FFB400" }} />}
        />
      )}
      {canShowMenu("atendimentos") && (
        <ListItemLink
          to="/tickets"
          primary={i18n.t("mainDrawer.listItems.tickets")}
          icon={<WhatsAppIcon style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("mensagens_pendentes") && (
        <ListItemLink
          to="/pending-messages"
          primary={i18n.t("mainDrawer.listItems.pendingMessages")}
          icon={<AutoModeIcon style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("tickets_conferencia") && (
        <ListItemLink
          to="/tickets-conference"
          primary={i18n.t("mainDrawer.listItems.ticketsConference")}
          icon={<CheckCircleOutlineIcon style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("relatorio_mensagens") && (
        <ListItemLink
          to="/messages-report"
          primary={i18n.t("mainDrawer.listItems.messagesReport")}
          icon={<ForumOutlinedIcon style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("monitoramento") && (
        <ListItemLink
          to="/attendance-monitor"
          primary={i18n.t("mainDrawer.listItems.attendanceMonitor")}
          icon={<Visibility style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("chat") && showInternalChat && (
        <ListItemLink
          to="/chats"
          primary={i18n.t("mainDrawer.listItems.chats")}
          icon={<ForumIcon style={{ color: "#4caf50" }} />}
        />
      )}
      {canShowMenu("fluxos") && showKanban && (
        <>
          <SidebarFlyout
            active={flyoutActive}
            panel={renderFlyoutPanel(i18n.t("mainDrawer.listItems.kanban"), fluxosItems, KANBAN_COLOR)}
          >
            <ListItem
              button
              dense
              selected={onKanbanRoute}
              onClick={(e) => { e.stopPropagation(); toggleFluxosSubmenu(); }}
            >
              <ListItemIcon>
                <FilterAltIcon style={{ color: KANBAN_COLOR }} />
              </ListItemIcon>
              <ListItemText primary={<span style={{ color: KANBAN_COLOR }}>{i18n.t("mainDrawer.listItems.kanban")}</span>} />
              {openFluxosSubmenu ? (
                <ExpandLessIcon style={{ color: KANBAN_COLOR }} />
              ) : (
                <ExpandMoreIcon style={{ color: KANBAN_COLOR }} />
              )}
            </ListItem>
          </SidebarFlyout>
          <Collapse
            className={submenuNestedClass}
            in={openFluxosSubmenu}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {renderSubItems(fluxosItems, { color: KANBAN_COLOR, tooltip: flyoutActive })}
            </List>
          </Collapse>
        </>
      )}
      {canShowMenu("respostas_rapidas") && (
        <ListItemLink
          to="/quick-messages"
          primary={i18n.t("mainDrawer.listItems.quickMessages")}
          icon={<FlashOnIcon />}
        />
      )}
      {canShowMenu("modelos_documentos") && (
        <ListItemLink
          to="/document-templates"
          primary={i18n.t("mainDrawer.listItems.documentTemplates")}
          icon={<MuiIcons.Description />}
        />
      )}
      {canShowMenu("contatos") && (
        <ListItemLink
          to="/contacts"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon />}
        />
      )}
      {visibleSubItems(CLIENT_CENTRAL_ITEMS).length > 0 && (
        <>
          <SidebarFlyout
            active={flyoutActive}
            panel={renderFlyoutPanel(
              i18n.t("mainDrawer.listItems.clientCentral"),
              CLIENT_CENTRAL_ITEMS,
              clientCentralColor
            )}
          >
            <ListItem
              button
              dense
              selected={isSubmenuActive(CLIENT_CENTRAL_ITEMS)}
              onClick={(e) => { e.stopPropagation(); toggleClientCentralSubmenu(); }}
            >
              <ListItemIcon>
                <PeopleAltOutlinedIcon style={{ color: clientCentralColor }} />
              </ListItemIcon>
              <ListItemText primary={<span style={{ color: clientCentralColor }}>{i18n.t("mainDrawer.listItems.clientCentral")}</span>} />
              {openClientCentralSubmenu ? (
                <ExpandLessIcon style={{ color: clientCentralColor }} />
              ) : (
                <ExpandMoreIcon style={{ color: clientCentralColor }} />
              )}
            </ListItem>
          </SidebarFlyout>
          <Collapse
            className={submenuNestedClass}
            in={openClientCentralSubmenu}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {renderSubItems(CLIENT_CENTRAL_ITEMS, { color: clientCentralColor, tooltip: flyoutActive })}
            </List>
          </Collapse>
        </>
      )}
      {canShowMenu("agendamentos") && (
        <ListItemLink
          to="/schedules"
          primary={i18n.t("mainDrawer.listItems.schedules")}
          icon={<Schedule />}
        />
      )}
      {canShowMenu("tags") && (
        <ListItemLink
          to="/tags"
          primary={i18n.t("mainDrawer.listItems.tags")}
          icon={<LocalOfferIcon />}
        />
      )}
      {canShowMenu("frases_tag") && (
        <ListItemLink
          to="/tag-phrases"
          primary={i18n.t("mainDrawer.listItems.tagPhrases")}
          icon={<LabelImportantIcon />}
        />
      )}
      {visibleSubItems(FORBIDDEN_ITEMS).length > 0 && (
        <>
          <SidebarFlyout
            active={flyoutActive}
            panel={renderFlyoutPanel(i18n.t("mainDrawer.listItems.forbiddenWords"), FORBIDDEN_ITEMS)}
          >
            <ListItem
              button
              dense
              selected={isSubmenuActive(FORBIDDEN_ITEMS)}
              onClick={(e) => { e.stopPropagation(); toggleForbiddenSubmenu(); }}
            >
              <ListItemIcon>
                <BlockIcon />
              </ListItemIcon>
              <ListItemText primary={i18n.t("mainDrawer.listItems.forbiddenWords")} />
              {openForbiddenSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
          </SidebarFlyout>
          <Collapse
            className={submenuNestedClass}
            in={openForbiddenSubmenu}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {renderSubItems(FORBIDDEN_ITEMS, { tooltip: flyoutActive })}
            </List>
          </Collapse>
        </>
      )}
      {canShowMenu("desenvolvimento") && (
        <ListItemLink
          to="/desenvolvimento"
          primary={i18n.t("mainDrawer.listItems.development")}
          icon={<CodeRoundedIcon />}
        />
      )}
      {/* Administração */}
      {canShowMenu("campanhas") && (
        <>
          <Divider />
          <ListSubheader
            hidden={collapsed}
            style={{
              position: "relative",
              fontSize: "17px",
              textAlign: "left",
              paddingLeft: 20
            }}
            inset
            color="inherit">
            {i18n.t("mainDrawer.listItems.administration")}
          </ListSubheader>
          {showCampaigns && (
            <>
              <SidebarFlyout
                active={flyoutActive}
                panel={renderFlyoutPanel(
                  i18n.t("mainDrawer.listItems.campaigns"),
                  CAMPAIGN_ITEMS
                )}
              >
                <ListItem
                  button
                  dense
                  selected={isSubmenuActive(CAMPAIGN_ITEMS)}
                  onClick={(e) => { e.stopPropagation(); toggleCampaignSubmenu(); }}
                >
                  <ListItemIcon>
                    <EventAvailableIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t("mainDrawer.listItems.campaigns")}
                  />
                  {openCampaignSubmenu ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </ListItem>
              </SidebarFlyout>
              <Collapse
                className={submenuNestedClass}
                in={openCampaignSubmenu}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {renderSubItems(CAMPAIGN_ITEMS, { tooltip: flyoutActive })}
                </List>
              </Collapse>
            </>
          )}
        </>
      )}
      {user.super && canShowMenu("infos") && (
        <ListItemLink
          to="/announcements"
          primary={i18n.t("mainDrawer.listItems.annoucements")}
          icon={<AnnouncementIcon />}
        />
      )}
      {canShowMenu("openai") && showOpenAi && (
        <ListItemLink
          to="/prompts"
          primary={i18n.t("mainDrawer.listItems.prompts")}
          icon={<AllInclusive />}
        />
      )}
      {canShowMenu("integracoes") && showIntegrations && (
        <ListItemLink
          to="/queue-integration"
          primary={i18n.t("mainDrawer.listItems.queueIntegration")}
          icon={<DeviceHubOutlined />}
        />
      )}
      {canShowMenu("conexoes") && (
        <ListItemLink
          to="/connections"
          primary={i18n.t("mainDrawer.listItems.connections")}
          icon={
            <Badge badgeContent={connectionWarning ? "!" : 0} color="error">
              <SyncAltIcon />
            </Badge>
          }
        />
      )}
      {canShowMenu("templates_mensagem") && (
        <ListItemLink
          to="/message-templates"
          primary={i18n.t("mainDrawer.listItems.messageTemplates")}
          icon={<BorderColorIcon />}
        />
      )}
      {canShowMenu("catalogo") && (
        <ListItemLink
          to="/catalog"
          primary={i18n.t("mainDrawer.listItems.catalog")}
          icon={<MuiIcons.Storefront />}
        />
      )}
      {canShowMenu("lista_de_arquivos") && (
        <ListItemLink
          to="/files"
          primary={i18n.t("mainDrawer.listItems.files")}
          icon={<AttachFile />}
        />
      )}
      {canShowMenu("filas_e_chatbot") && (
        <ListItemLink
          to="/queues"
          primary={i18n.t("mainDrawer.listItems.queues")}
          icon={<AccountTreeOutlinedIcon />}
        />
      )}
      {canShowMenu("usuarios") && (
        <ListItemLink
          to="/users"
          primary={i18n.t("mainDrawer.listItems.users")}
          icon={<PeopleAltOutlinedIcon />}
        />
      )}
      {canShowMenu("api") && showExternalApi && (
        <ListItemLink
          to="/messages-api"
          primary={i18n.t("mainDrawer.listItems.messagesAPI")}
          icon={<CodeRoundedIcon />}
        />
      )}
      {canShowMenu("financeiro") && (
        <ListItemLink
          to="/financeiro"
          primary={i18n.t("mainDrawer.listItems.financeiro")}
          icon={<LocalAtmIcon />}
        />
      )}
      {canShowMenu("perfis") && (
        <ListItemLink
          to="/perfis"
          primary={i18n.t("mainDrawer.listItems.perfis")}
          icon={<PeopleIcon />}
        />
      )}
      {/* Administração da plataforma (faturamento e uso dos clientes). Sem
          canShowMenu: é exclusivo do dono do sistema, não passa pelos Perfis. */}
      {user?.id === 1 && (
        <ListItemLink
          to="/gerenciamento"
          primary={i18n.t("mainDrawer.listItems.management")}
          icon={<MuiIcons.BusinessCenterOutlined />}
        />
      )}
      {canShowMenu("configs") && (
        <ListItemLink
          to="/settings"
          primary={i18n.t("mainDrawer.listItems.settings")}
          icon={<SettingsOutlinedIcon />}
        />
      )}
    </div>
    </SidebarUIContext.Provider>
  );
};

export default MainListItems;
